import React from "react";
import { useTheme } from "@emotion/react";

import { IconContainer } from "./styles";

import { AppTheme } from "myplan/utils/theme";
import {
    PhoneIcon,
    SmsIcon as SMS,
    PhoneWhiteIcon,
    SmsWhiteIcon,
    UnderstandIcon,
    ProtectIcon,
    ReachOutIcon,
    TakeCareIcon,
    MakeaPlanIcon,
    SafetyOnlineIcon,
    EndingRelationshipIcon,
    PlanSafetyIcon,
    PregnantIcon,
    TakeCareHealthIcon,
    HealthierRelationshipIcon,
    TakeCareOfMyHealthIcon,
    WellBeingIcon,
    TakeCareOfYourselfIcon,
    GetLegalHelpIcon,
    TalkingToYourFriendIcon,
    LegalIcon,
    ChildrenIcon,
    OfferSupportIcon,
    StayingSafeIcon,
    HealthIcon,
    SelfCareIcon,
    LGBTQIcon,
    MentalHealthIcon,
    ParentingAndPregancyIcon,
} from "myplan/components/Icon";

// default red icons
const labelToImg = {
    ICON_PRIVATE_ONLINE: SafetyOnlineIcon,
    ICON_ENDING_RELATIONSHIP: EndingRelationshipIcon,
    ICON_SAFETY: PlanSafetyIcon,
    ICON_SAFE_WHILE_PREGNANT: PregnantIcon,
    ICON_TAKE_CARE_HEALTH: TakeCareHealthIcon,
    ICON_REACH_OUT: ReachOutIcon,
    ICON_HEALTHIER_RELATIONSHIP: HealthierRelationshipIcon,
    ICON_UNDERSTAND: UnderstandIcon,
    ICON_PROTECT: ProtectIcon,
    ICON_TAKE_CARE: TakeCareIcon,
    ICON_MAKE_A_PLAN: MakeaPlanIcon,
    ICON_LEGAL: LegalIcon,
    ICON_CHILDREN: ChildrenIcon,
    ICON_SUPPORT: OfferSupportIcon,
    ICON_CALL: PhoneIcon,
    ICON_SMS: SMS,
    ICON_STAYING_SAFE: StayingSafeIcon,
    ICON_HEALTH: HealthIcon,
    ICON_SELF_CARE: SelfCareIcon,
    ICON_LGBTQ: LGBTQIcon,
    ICON_SMS_EXTRA: SmsWhiteIcon,
    ICON_CALL_EXTRA: PhoneWhiteIcon,
    ICON_MENTAL_HEALTH: MentalHealthIcon,
    ICON_TAKE_CARE_OF_MY_HEALTH: TakeCareOfMyHealthIcon,
    ICON_WELL_BEING: WellBeingIcon,
    ICON_TAKE_CARE_OF_YOURSELF: TakeCareOfYourselfIcon,
    ICON_GET_LEGAL_HELP: GetLegalHelpIcon,
    ICON_TALKING_TO_YOUR_FRIEND: TalkingToYourFriendIcon,
    ICON_PARENTING_AND_PREGANCY: ParentingAndPregancyIcon,
};

const defaultIcon = "ICON_UNDERSTAND";

const CategoryIcon = ({ icon = defaultIcon, style = null, extra = false }) => {
    const {
        color: { enabled },
    }: AppTheme = useTheme() as AppTheme;
    let Icon = labelToImg[defaultIcon];
    const iconStyle = { color: enabled };

    if (Object.keys(labelToImg).indexOf(icon) > -1) {
        Icon = labelToImg[icon];
    }
    if (extra && (icon.includes("CALL") || icon.includes("SMS"))) {
        Icon = labelToImg[`${icon}_EXTRA`];
    }
    return (
        <IconContainer>
            <Icon width={"75%"} height={"80%"} style={iconStyle} />
        </IconContainer>
    );
};

export default CategoryIcon;
